import React, {Component} from 'react';
import {connect} from 'react-redux';
import moment from 'moment';
import {Grid, Dropdown, Button} from 'semantic-ui-react';
import {PANES_INDICES} from '../../../common/dictionaries/kpis';
import {monthFormat, yearFormat} from '../../../common/constants/datesFormat';
import {getYears, getAllOptionsMonths} from './utils';
import {Actions} from '../../../common/actions';

const currentYear = parseInt(moment().format(yearFormat), 10);
const currentMonth = parseInt(moment().format(monthFormat), 10);

class FiltersSalesKpiSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'initialYearTmp': currentYear,
      'initialYearSelected': currentYear,
      'finalYearTmp': currentYear,
      'finalYearSelected': currentYear,
      'monthTmp': currentMonth,
      'monthSelected': currentMonth,
      'lastYearWithData': currentYear,
      'lastMonthWithData': currentMonth,
    };
    this.onClearClick = this.onClearClick.bind(this);
    this.onFilterClick = this.onFilterClick.bind(this);
    this.updateYearsToLatestSalesYear = this.updateYearsToLatestSalesYear.bind(this);
  }

  updateYearsToCurrentYear(newState) {
    newState.initialYearTmp = currentYear;
    newState.initialYearSelected = currentYear;
    newState.finalYearTmp = currentYear;
    newState.finalYearSelected = currentYear;
    newState.lastYearWithData = currentYear;
    return newState;
  }

  updateYearsToLatestSalesYear(newState, latestSales) {
    newState.initialYearTmp = latestSales.year;
    newState.initialYearSelected = latestSales.year;
    newState.lastYearWithData = latestSales.year;
    return newState;
  }

  componentDidUpdate(prevProps) {
    const {latestSales, activeTabIndex} = this.props;
    const isSalesByAgency = activeTabIndex === PANES_INDICES.SALES_BY_AGENCY;
    if (!isSalesByAgency || !Object.keys(latestSales).length || prevProps.latestSales === latestSales) {
      return;
    }
    let newState = {};
    if (activeTabIndex !== prevProps.activeTabIndex) {
      newState = this.updateYearsToCurrentYear(newState);
    }
    const {initialYearSelected, monthSelected} = this.state;
    if (latestSales.year !== initialYearSelected) {
      newState = this.updateYearsToLatestSalesYear(newState, latestSales);
    }
    if (latestSales.month !== monthSelected) {
      newState.monthTmp = latestSales.month;
      newState.monthSelected = latestSales.month;
      newState.lastMonthWithData = latestSales.month;
    }
    this.setState(newState);
  }

  changeYear(value, type) {
    if (type === 'initial') {
      this.setState({'initialYearTmp': value}, () => this.updateDataForInitialYear());
      return;
    }
    this.setState({'finalYearTmp': value}, () => this.updateDataForFinalYear());
  }

  updateDataForInitialYear() {
    const {
      initialYearSelected,
      initialYearTmp,
      finalYearSelected,
      monthSelected,
      lastYearWithData,
      lastMonthWithData,
    } = this.state;
    if (initialYearSelected === initialYearTmp) {
      return;
    }

    const newState = {
      'initialYearSelected': initialYearTmp,
      'finalYearSelected': finalYearSelected,
    };
    if (
      (initialYearTmp === currentYear && finalYearSelected < currentYear) ||
      initialYearTmp > finalYearSelected
    ) {
      newState.finalYearTmp = initialYearTmp;
      newState.finalYearSelected = initialYearTmp;
    }
    if (
      initialYearTmp === lastYearWithData &&
      monthSelected > lastMonthWithData
    ) {
      newState.monthTmp = lastMonthWithData;
      newState.monthSelected = lastMonthWithData;
    }
    this.setState(newState, () => this.props.updateShowData(false));
  }

  updateDataForFinalYear() {
    const {finalYearSelected, finalYearTmp} = this.state;
    if (finalYearSelected !== finalYearTmp) {
      this.setState({'finalYearSelected': finalYearTmp}, () => {
        this.props.updateShowData(false);
        this.onFilterClick();
      });
    }
  }

  changeMonth(value) {
    this.setState({'monthTmp': value}, () => this.updateDataForMonth());
  }

  updateDataForMonth() {
    const {monthSelected, monthTmp} = this.state;
    if (monthSelected !== monthTmp) {
      this.setState({'monthSelected': monthTmp}, () => {
        this.props.updateShowData(false);
        this.onFilterClick();
      });
    }
  }

  renderSecondFilter() {
    const {loadingSalesVsBudgets, activeTabIndex} = this.props;
    const {monthTmp, finalYearTmp, lastYearWithData, initialYearSelected,
      lastMonthWithData} = this.state;
    const isSalesByAgency = activeTabIndex === PANES_INDICES.SALES_BY_AGENCY;
    if (isSalesByAgency) {
      return (
        <Dropdown
          selection
          options={getAllOptionsMonths({
            lastYearWithData,
            lastMonthWithData,
            initialYearSelected,
          })}
          search
          value={monthTmp}
          onChange={(e, {value}) => this.changeMonth(value)}
          placeholder='Mes'
          noResultsMessage='Mes no encontrado'
        />
      );
    }

    return (
      <Dropdown
        selection
        options={getYears('final', lastYearWithData, initialYearSelected)}
        search
        value={finalYearTmp}
        disabled={loadingSalesVsBudgets}
        loading={loadingSalesVsBudgets}
        onChange={(e, {value}) => this.changeYear(value, 'final')}
        placeholder='Año Final'
        noResultsMessage='Año no encontrado'
      />
    );
  }

  onClearClick() {
    const newState = {
      'initialYearTmp': currentYear,
      'initialYearSelected': currentYear,
      'finalYearTmp': currentYear,
      'finalYearSelected': currentYear,
      'monthTmp': currentMonth,
      'monthSelected': currentMonth,
    };

    const {activeTabIndex} = this.props;
    const isSalesByAgency = activeTabIndex === PANES_INDICES.SALES_BY_AGENCY;
    const {lastYearWithData, lastMonthWithData} = this.state;
    if (isSalesByAgency) {
      newState.initialYearTmp = lastYearWithData;
      newState.initialYearSelected = lastYearWithData;
      newState.monthTmp = lastMonthWithData;
      newState.monthSelected = lastMonthWithData;
    }
    this.setState(newState, () => this.props.updateShowData(false));
  }

  onFilterClick() {
    const {activeTabIndex} = this.props;
    const {initialYearSelected, finalYearSelected, monthSelected} = this.state;
    const isSalesByAgency = activeTabIndex === PANES_INDICES.SALES_BY_AGENCY;
    this.props.updateShowData(true);

    this.props.clearSales();
    if (isSalesByAgency) {
      const month = monthSelected === 'ALL' ? '' : monthSelected;
      this.props.fetchSalesByDealer(initialYearSelected, month);
      return;
    }
    this.props.fetchSalesAndBudgets(initialYearSelected, finalYearSelected);
  }

  renderSearchButton() {
    const {loadingSalesVsBudgets} = this.props;
    return (
      <Button
        type='button'
        primary
        className='toyota-primary'
        disabled={loadingSalesVsBudgets}
        loading={loadingSalesVsBudgets}
        onClick={this.onFilterClick}
      >
        Filtrar
      </Button>
    );
  }

  renderClearButton() {
    const {loadingSalesVsBudgets} = this.props;
    return (
      <Button
        type='button'
        secondary
        className='toyota-primary'
        disabled={loadingSalesVsBudgets}
        loading={loadingSalesVsBudgets}
        onClick={this.onClearClick}
      >
        Limpiar
      </Button>
    );
  }

  render() {
    const {initialYearTmp, lastYearWithData, initialYearSelected} = this.state;
    const {loadingSalesVsBudgets, activeTabIndex} = this.props;
    const isSalesByAgency = activeTabIndex === PANES_INDICES.SALES_BY_AGENCY;
    const titleInitialYear = isSalesByAgency ? 'Año' : 'Año de Inicio';
    const titleFinalYearOrMonth = isSalesByAgency ? 'Mes' : 'Año Final';

    return (
      <div className='title-bar'>
        <div className='filters-section'>
          <Grid textAlign='left'>
            <Grid.Row>
              <Grid.Column width={1} className='order-label'>
                <h4>{titleInitialYear}</h4>
              </Grid.Column>
              <Grid.Column width={3}>
                <Dropdown
                  selection
                  options={getYears('initial', lastYearWithData, initialYearSelected)}
                  search
                  value={initialYearTmp}
                  disabled={loadingSalesVsBudgets}
                  loading={loadingSalesVsBudgets}
                  onChange={(e, {value}) => this.changeYear(value, 'initial')}
                  placeholder='Año Inicial'
                  noResultsMessage='Año no encontrado'
                />
              </Grid.Column>
              <Grid.Column width={1} className='order-label'>
                <h4>{titleFinalYearOrMonth}</h4>
              </Grid.Column>
              <Grid.Column width={3}>{this.renderSecondFilter()}</Grid.Column>
              <Grid.Column width={8} textAlign='right'>
                {this.renderClearButton()}
                {this.renderSearchButton()}
              </Grid.Column>
            </Grid.Row>
          </Grid>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    'latestSales': state.sales.latestSales,
    'loadingSalesVsBudgets': state.sales.loadingSalesVsBudgets,
  };
};

const {
  clearSales,
  fetchSalesByDealer,
  fetchSalesAndBudgets,
} = Actions;

export default connect(mapStateToProps, {
  clearSales,
  fetchSalesByDealer,
  fetchSalesAndBudgets,
})(FiltersSalesKpiSection);
